import { DateFormatEnum, LocaleEnum, RegionEnum } from '@libs/graphql-types';

export const DEFAULT_LOCALE = 'en-US';

const LOCALE_ENUM_MAP: Record<LocaleEnum, string> = {
  [LocaleEnum.EnUs]: 'en-US',
  [LocaleEnum.EnAu]: 'en-AU',
};

const DATE_FORMAT_LOCALE_MAP: Record<DateFormatEnum, string> = {
  [DateFormatEnum.Us]: 'en-US',
  [DateFormatEnum.Aus]: 'en-AU',
};

export const localeEnumToI18n = (
  locale: LocaleEnum | null | undefined,
): string => (locale ? LOCALE_ENUM_MAP[locale] : DEFAULT_LOCALE);

export const dateFormatEnumToLocale = (
  format: DateFormatEnum | null | undefined,
  fallbackLocale: string,
): string => (format ? DATE_FORMAT_LOCALE_MAP[format] : fallbackLocale);

/** @deprecated Use localeEnumToI18n with account_settings.locale instead */
const REGION_LOCALE_MAP: Record<RegionEnum, string> = {
  [RegionEnum.Us]: 'en-US',
  [RegionEnum.Europe]: 'en-US',
  [RegionEnum.Australia]: 'en-AU',
};

const isRegionEnum = (value: string): value is RegionEnum =>
  Object.values(RegionEnum).includes(value as RegionEnum);

/** @deprecated Use localeEnumToI18n with account_settings.locale instead */
export const regionToLocale = (
  region: string | undefined,
): string | undefined =>
  region && isRegionEnum(region) ? REGION_LOCALE_MAP[region] : undefined;
